import { AccessGuids, AlertClassColour, ConfigSystemParams, DashboardProfit, DgAlignment, DgColumnDataType, DgColumnWidths, eSimApiPaths, GridViewTitles, OurColors } from 'src/app/core/consts';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { BooleanService } from 'src/app/core/services/utelize/general/boolean-service';
import { BulkOrderSummaryDTO } from 'src/app/core/models/system/order/order-bulk-summary.dto';
import { catchError, forkJoin, from, lastValueFrom, Observable, of, throwError, ReplaySubject, takeUntil, timer } from 'rxjs';
import { CompaniesService } from 'src/app/core/services/utelize/system/company/companies-service';
import { CompletedModalNRFormComponent } from 'src/app/forms-modal-confirmation/completed-modal-form/completed-modal-form.component';
import { CountriesService } from 'src/app/core/services/utelize/system/mapping/countries-service';
import { CountryDTO } from 'src/app/core/models/system/mapping/country.dto';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ConfirmationModalNRFormComponent } from 'src/app/forms-modal-confirmation/confirmation-modal-form/confirmation-modal-form.component';
import CustomStore from 'devextreme/data/custom_store';
import { DashboardStatistic } from 'src/app/core/interfaces/general/dashboard-statistic';
import { DeviceActivationType, DeviceOSType, eDeviceType, LimitType } from 'src/app/core/enums';
import { DevicesService } from 'src/app/core/services/utelize/system/device/devices-service';
import { DgActionColumn } from 'src/app/core/interfaces/datagrid/dg-action-column';
import { DgApiPath } from 'src/app/core/interfaces/datagrid/dg-api-paths';
import { DgColumn } from 'src/app/core/interfaces/datagrid/dg-column';
import { DgPopup } from 'src/app/core/interfaces/datagrid/dg-pop-up';
import { DgProperties } from 'src/app/core/interfaces/datagrid/dg-properties';
import { DgTab } from 'src/app/core/interfaces/datagrid/dg-tab';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { formatDate } from 'devextreme/localization';
import { GridViewComponent } from 'src/app/core/grid-view/component/grid-view.component';
import { GridViewDefaults } from 'src/app/core/grid-view/component/grid-view.defaults';
import { GridViewService } from 'src/app/core/services/utelize/general/grid-view.service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { InviewCostCentresService } from 'src/app/core/services/utelize/inview/inview-cost-centres-service';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { OrdersService } from 'src/app/core/services/utelize/system/order/orders-service';
import { PageCompHeaderComponent } from "src/app/core/page-components/page-comp-header/page-comp-header.component"
import { PhoneNumberService } from 'src/app/core/services/utelize/general/phone-number-service';
import { ProductsService } from 'src/app/core/services/utelize/system/product/products-service';
import { saveAs } from 'file-saver';
import { statData } from 'src/app/core/data';
import { Validators } from '@angular/forms';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';
import { Workbook } from 'exceljs';
import * as XLSX from 'xlsx';

const apiPath                =environment.eSimApi+eSimApiPaths.OrdersBulk;
const exportFilenameSuffix   ="Bulk-Provision-Data";
const mainTitle              =GridViewTitles.simProvisionBulkEmbedded;
const parentSection          ="Available SIMS";
const popUpTitle             =GridViewTitles.simProvisionBulkEmbedded;
const processingKeyWordSearch="Processing ";
const provisioningStatus     ="Processing";
const thisSection            =GridViewTitles.simProvisionBulkEmbedded;

//RBW_20260604 - Lookup options for the new bulk template columns. Ids match the backend PublicEnums (EspTypesDeviceActivation / EspTypesDevice / EspTypesDeviceOS)
const deviceOSOptions     : IdAndDescriptionDTO[] = [{ id: DeviceOSType.AppleIOS,             description: "Apple iOS"},
                                                     { id: DeviceOSType.Android,              description: "Android"  },
                                                     { id: DeviceOSType.Windows,              description: "Windows"  }];
const provisionTypeOptions: IdAndDescriptionDTO[] = [{ id: DeviceActivationType.PushViaEID,    description: "EID"      },
                                                     { id: DeviceActivationType.PushViaICCID,  description: "ICCID"    },
                                                     { id: DeviceActivationType.SendViaSMS,    description: "SMS"      },
                                                     { id: DeviceActivationType.SendViaEmail,  description: "Email"    },
                                                     { id: DeviceActivationType.SendViaManual, description: "Manual"   }];
const simTypeOptions      : IdAndDescriptionDTO[] = [{ id: eDeviceType.esim,                  description: "eSIM"     },
                                                     { id: eDeviceType.sim,                   description: "SIM"      }];
const useTypeOptions      : IdAndDescriptionDTO[] = [{ id: false,                             description: "Physical User" },
                                                     { id: true,                              description: "IOT Device"    }];

const greyForIot           = (r: any): boolean => r?.isIOTDevice === true;                                                                        // name/email/mobile/cost centres - not used for an IOT device
const greyEidCell          = (r: any): boolean => r?.simType === eDeviceType.sim || (r?.provisionType != null && r?.provisionType !== DeviceActivationType.PushViaEID); // EID - not for a physical SIM, nor SMS/Email/Manual
const greyIccidCell        = (r: any): boolean => r?.simType === eDeviceType.esim;                                                                // ICCID - only a physical SIM uses one
const greyDeviceOSCell     = (r: any): boolean => r?.provisionType === DeviceActivationType.PushViaEID || r?.provisionType === DeviceActivationType.PushViaICCID || r?.provisionType === DeviceActivationType.SendViaManual; // Device OS - only needed for SMS/Email
const greyLimitTypeCell    = (r: any): boolean => r?.inheritCompanyLimit === true;                                                                // Limit Type - only when NOT inheriting the company limit
const greyActivationCell   = (r: any): boolean => r?.provisionType !== DeviceActivationType.SendViaManual;                                        // Activation Server/Code - only captured for Manual deployment

const greyForIotReason      = (_r: any): string => "Not required when Use Type is IOT Device";
const greyEidReason         = (r: any): string  => r?.simType === eDeviceType.sim
                                                   ? "Not required when Sim Type is SIM"
                                                   : "Not required when Deploy Method is not EID";
const greyIccidReason       = (_r: any): string => "Not required when Sim Type is eSIM";
const greyDeviceOSReason    = (_r: any): string => "Only required when Deploy Method is SMS or Email";
const greyLimitReason       = (_r: any): string => "Not required when Inherit Company Limit is Yes";
const greyActivationReason  = (_r: any): string => "Only applicable when Deploy Method is Manual";

const abbreviateProduct = (value: any): string => {
  let text = (value ?? "").toString();
  text = text.split("PAYG – ").join("");
  text = text.split("Open Profile").join("OP");
  text = text.split("(Premium Zone Barred)").join("(PZ Barred)");
  text = text.split("Breakout").join("");
  text = text.split("Business Unlimited").join("BU");
  text = text.split("Business Profile").join("BP");
  return text;
};

@Component({
  selector: 'app-sim-provision-bulk',
  templateUrl: './sim-provision-bulk.component.html',
  styleUrls: ['./sim-provision-bulk.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SimProvisionBulkEmbeddedComponent implements OnInit {
  
  @Input() extraGridHeightOffset : number  = 0;
  @Input() initialCompanyId      : number  | undefined;
  @Input() initialInviewCompanyId: number  | undefined;
  @Input() showCancelButton      : boolean = true;

  @Output() bulkProvisionButtonClick: EventEmitter<void  >=new EventEmitter<void  >();
  @Output() companyIdChanged        : EventEmitter<number>=new EventEmitter<number>();
  @Output() formClosed              : EventEmitter<void  >=new EventEmitter<void  >();
  @Output() gridOrderLinkClick      : EventEmitter<number>=new EventEmitter<number>();
  @Output() gridUserLinkClick       : EventEmitter<number>=new EventEmitter<number>();
  @Output() viewEmailTemplateClick  : EventEmitter<void  >=new EventEmitter<void  >();
  @Output() viewSmsTemplateClick    : EventEmitter<void  >=new EventEmitter<void  >();

  @Output() gridEditRowClick: EventEmitter<{ orderGuid: string, orderId: number, validationMessages: string[], userExists: boolean }>=new EventEmitter<{ orderGuid: string, orderId: number, validationMessages: string[], userExists: boolean }>();

  @ViewChild('ArrowNgbNav')                                      arrowNav!                       : NgbNav;
  @ViewChild('clearErrorsConfirmationModal',   { static: false }) clearErrorsConfirmationModal!  : ConfirmationModalNRFormComponent;
  @ViewChild('completedModalForm',             { static: false }) completedModalForm!            : CompletedModalNRFormComponent;
  @ViewChild('createUsersConfirmationModal',   { static: false }) createUsersConfirmationModal!  : ConfirmationModalNRFormComponent;
  @ViewChild('deleteBulkConfirmationModal',    { static: false }) deleteBulkConfirmationModal!   : ConfirmationModalNRFormComponent;
  @ViewChild('deleteConfirmationModal',        { static: false }) deleteConfirmationModal!       : ConfirmationModalNRFormComponent;
  @ViewChild('fileInput',                      { static: false }) fileInput!                     : ElementRef;
  @ViewChild('gridView',                       { static: false }) gridView!                      : GridViewComponent;
  @ViewChild('pageheader',                     { static: false }) pageheader!                    : PageCompHeaderComponent;
  @ViewChild('provisionBulkConfirmationModal', { static: false }) provisionBulkConfirmationModal!: ConfirmationModalNRFormComponent;
  @ViewChild('reserveSimsConfirmationModal',   { static: false }) reserveSimsConfirmationModal!  : ConfirmationModalNRFormComponent;
  @ViewChild('sendManualConfirmationModal',    { static: false }) sendManualConfirmationModal!   : ConfirmationModalNRFormComponent;
  @ViewChild('updateInviewConfirmationModal',  { static: false }) updateInviewConfirmationModal! : ConfirmationModalNRFormComponent;
  @ViewChild('warningModalForm',               { static: false }) warningModalForm!              : WarningModalFormComponent;
  
  get columnMinWidth              ()           { return this.configSystemService.getValueAsInteger (ConfigSystemParams.GridDefaultColumnMinWidth,      150   ); }
  get showCostCentres             () : boolean { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ProvisioningBulkShowCostCentres, true  ); }
  get titlesEmbedButtons          ()           { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.PagesTitlesEmbedButtons,         true  ); }
  get titlesEmbedCompanyDropDown  ()           { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.PagesTitlesEmbedCompanyDropDown, true  ); }
  get titlesEmbedBulkOrderDropDown()           { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.PagesTitlesEmbedCompanyDropDown, true  ); }
  get useInternationalDialCode    () : boolean { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserUseInternationalDialCode, false); }

  private countriesCache               : CountryDTO[] = [];
  private curUserID                    : number;
  private gridViewDefaults!            : GridViewDefaults;
  private selectedInviewCostCentreLv2? : IdAndDescriptionDTO;
  private statusCheck                  : ReplaySubject<boolean> = new ReplaySubject(1);
  private statsGotProvisioningProgress : boolean=false;
  private statsGotTotalRequestCount    : boolean=false;
  private statsGotTotalValidCount      : boolean=false;
  private statsGotTotalInvalidCount    : boolean=false;
  private statsGotTotalProvisionedCount: boolean=false;
  private statsGotTotalErroredCount    : boolean=false;
  private statusObservable             : Observable<number> | undefined;

  public activeId                 : number = 1;
  public alertColourInvalid       : string=AlertClassColour.Red;
  public breadCrumbItems!         : Array<{}>;
  public companyCurrencySymbol    : string = "£";
  public createUsersCount         : number=0;
  public curUserCompanyID         : number | undefined;
  public deleteButtonEnabled      : boolean=false;
  public deleteInProgress         : boolean=false;
  public dgApiPath!               : DgApiPath | undefined;
  public dgActionColumn!          : DgActionColumn | undefined;
  public dgColumns!               : Array<DgColumn>;
  public dgPopup!                 : DgPopup | undefined;
  public dgProperties!            : DgProperties | undefined;
  public dgTabs!                  : Array<DgTab>;
  public filterBulkOrderGuid      : string="";
  public filterCompanyID          : number | undefined;
  public filterInviewCompanyID    : number | undefined;
  public instructionsCollapsed    : boolean=false;
  public manualActivationCount    : number=0;
  public noBulkOrderSelected      : boolean=true;
  public provisionButtonEnabled   : boolean=false;
  public provisioningInProgress   : boolean=false;
  public reserveSimsCount         : number=0;
  public selectedBulkOrderSummary : BulkOrderSummaryDTO | undefined;
  public selectedFile             : string="";
  public selectedRowData          : any;
  public showUploadMessages       : boolean=false;
  public statData!                : any;
  public sureSimStatData!         : Array<DashboardStatistic>;
  public title                    : string=mainTitle;
  public updateInviewCount        : number=0;
  public uploadInProgress         : boolean=false;
  public uploadMessages           : string[] = [];
  public uploadTitle              : string="";
  public warningMessageMain       : string | undefined;
  public warningMessageSub        : string | undefined;
  
  //#region NavItems

  public navItemLog_All         : number=1;
  public navItemLog_Valid       : number=2;
  public navItemLog_Invalid     : number=3;
  public navItemLog_Provisioned : number=4;
  public navItemLog_Errored     : number=5;
  public navItemLog_InProgress  : number=6;

  //#endregion

  constructor(
    private authenticationService     : AuthenticationService,
    private booleanService            : BooleanService,
    private companiesService          : CompaniesService,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private countriesService          : CountriesService,
    private devicesService            : DevicesService,
    private exceptionsService         : ExceptionsService,
    private gridViewService           : GridViewService,
    private inviewCostCentresService  : InviewCostCentresService,
    private phoneNumberService        : PhoneNumberService,
    private productsService           : ProductsService,
    private ordersService             : OrdersService,
  ) {
    this.curUserID       =this.authenticationService.currentUserObject().userId;
    this.gridViewDefaults=new GridViewDefaults(this.authenticationService, this.componentAccessUserService, this.configSystemService, this.exceptionsService);
  }

  public ngOnInit(): void {
    try {
      this.filterCompanyID       =this.initialCompanyId;
      this.filterInviewCompanyID =this.initialInviewCompanyId;

      this.breadCrumbItems = [
        { label: parentSection },
        { label: thisSection, active: true }
      ];
      this.filterBulkOrderGuid = crypto.randomUUID();
      this.setUpDgProperties();
      this.setUpDgApiPaths();
      this.setUpDgActionColumn();
      this.setUpDgColumns();
      this.setUpDgPopup();
      this.setUpDgTabs();
      this.fetchData();
      this.displayDashboardData();

      if (this.useInternationalDialCode) {
        this.countriesService.get()
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next : data => { this.countriesCache = <CountryDTO[]>(data ?? []); },
          error: error => { this.exceptionsService.handleException(new Error(error)); }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      if (this.noBulkOrderSelected) {
        //if (this.statsGotTotalRequestCount == false)
        {
          this.sureSimStatData.forEach((stat: DashboardStatistic) => {
            if (stat.title=="TOTAL ENTRIES")
            {
              stat.loading   =false,
              stat.percentage="",
              stat.profit    ="",
              stat.value     =undefined
            }
          });
        }
    
        //if (this.statsGotTotalValidCount == false)
        {
          this.sureSimStatData.forEach((stat: DashboardStatistic) => {
            if (stat.title=="TOTAL VALID")
            {
              stat.loading   =false,
              stat.percentage="",
              stat.profit    ="",
              stat.value     =undefined
            }
          });
        }  
  
        //if (this.statsGotTotalInvalidCount == false)
        {
          this.sureSimStatData.forEach((stat: DashboardStatistic) => {
            if (stat.title=="TOTAL INVALID")
            {
              stat.loading   =false,
              stat.percentage="",
              stat.profit    ="",
              stat.value     =undefined
            }
          });
        }
  
        //if (this.statsGotTotalProvisionedCount == false)
        {
          this.sureSimStatData.forEach((stat: DashboardStatistic) => {
            if (stat.title=="TOTAL PROVISIONED")
            {
              stat.loading   =false,
              stat.percentage="",
              stat.profit    ="",
              stat.value     =undefined
            }
          });
        }

        //if (this.statsGotTotalErroredCount == false)
        {
          this.sureSimStatData.forEach((stat: DashboardStatistic) => {
            if (stat.title=="TOTAL ERRORED")
            {
              stat.loading   =false,
              stat.percentage="",
              stat.profit    ="",
              stat.value     =undefined
            }
          });
        }

        //if (this.statsGotProvisioningProgress == false)
        {
          this.sureSimStatData.forEach((stat: DashboardStatistic) => {
            if (stat.title=="PROVISIONING PROGRESS")
            {
              stat.loading   =false,
              stat.percentage="",
              stat.profit    ="",
              stat.value     =""
            }
          });
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

private fetchData() {
    this.statData = statData;
  }

  private displayDashboardData() {
    try {
      this.sureSimStatData=[];

      let statTotalProvisioningRequests: DashboardStatistic={
        decimalPlaces : 0,
        icon          : "bx-list-ul", //bx bx-list-plus
        iconColour    : "info",
        link          : "/provisioning/devices-allocated",
        linkText      : undefined,
        loading       : false,
        percentage    : <string><unknown>"",
        profit        : "",
        profitUpIsGood: true,
        showProfit    : false,
        showSpinner   : false,
        title         : "TOTAL ENTRIES",
        value         : undefined,
      }
                  
      let statTotalValid: DashboardStatistic={
        decimalPlaces : 0,
        icon          : "bx-check", // "bx bx-happy",
        iconColour    : "success",
        link          : "/provisioning/devices-allocated",
        linkText      : undefined,
        loading       : false,
        percentage    : <string><unknown>"",
        profit        : "",
        profitUpIsGood: true,
        showProfit    : false,
        showSpinner   : false,
        title         : "TOTAL VALID",
        value         : undefined,
      }

      let statTotalInvalid: DashboardStatistic={
        decimalPlaces : 0,
        icon          : "bx-x", //bx bx-sad    bx bx-question-mark
        iconColour    : "danger",
        link          : "/provisioning/devices-allocated",
        linkText      : undefined,
        loading       : false,
        percentage    : <string><unknown>"",
        profit        : "",
        profitUpIsGood: true,
        showProfit    : false,
        showSpinner   : false,
        title         : "TOTAL INVALID",
        value         : undefined,
      }
  
      let statTotalProvisioned: DashboardStatistic={
        decimalPlaces : 0,
        icon          : "bx-like", //bx-phone
        iconColour    : "success",
        link          : "/provisioning/devices-allocated",
        linkText      : undefined, //"View SIMs"
        loading       : false,
        percentage    : <string><unknown>"",
        profit        : "",
        profitUpIsGood: true,
        showProfit    : false,
        showSpinner   : false,
        title         : "TOTAL PROVISIONED",
        value         : undefined,
      }

      let statTotalErrored: DashboardStatistic={
        decimalPlaces : 0,
        icon          : "bx-dislike", //bx bx-error
        iconColour    : "danger",
        link          : "/provisioning/devices-allocated",
        linkText      : undefined, //"View SIMs"
        loading       : false,
        percentage    : <string><unknown>"",
        profit        : "",
        profitUpIsGood: true,
        showProfit    : false,
        showSpinner   : false,
        title         : "TOTAL ERRORED",
        value         : undefined,
      }

      let statProvisionStatus: DashboardStatistic={
        decimalPlaces : 0,
        icon          : "bx-timer", //bx-phone
        iconColour    : "warning",
        link          : "/provisioning/devices-allocated",
        linkText      : undefined, //"View SIMs"
        loading       : false,
        percentage    : <string><unknown>"",
        profit        : "",
        profitUpIsGood: true,
        showProfit    : false,
        showSpinner   : false,
        title         : "PROVISIONING PROGRESS",
        value         : "",
      }

      this.sureSimStatData.push(statTotalProvisioningRequests);
      this.sureSimStatData.push(statTotalValid);
      this.sureSimStatData.push(statTotalInvalid);
      this.sureSimStatData.push(statTotalProvisioned);
      this.sureSimStatData.push(statTotalErrored);
      this.sureSimStatData.push(statProvisionStatus);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }

  private async getDashboardData() {
    try {
    if (this.statsGotTotalRequestCount     ==false ||
        this.statsGotTotalValidCount       ==false ||
        this.statsGotTotalInvalidCount     ==false || 
        this.statsGotTotalProvisionedCount ==false || 
        this.statsGotTotalErroredCount     ==false || 
        this.statsGotProvisioningProgress  ==false) {
      this.getBulkOrderSummary();
    }

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
  
  public getBulkOrderSummary() {
    try {
      this.ordersService.getBulkOrderSummary(this.filterBulkOrderGuid)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.selectedBulkOrderSummary = data;
          if (!this.statsGotTotalRequestCount) {
            this.statsGotTotalRequestCount=true;
                                   
            this.sureSimStatData.forEach((stat: DashboardStatistic) => {
              if (stat.title == "TOTAL ENTRIES")
              {
                stat.loading    = false,
                stat.percentage = <string><unknown>0,
                stat.profit     = DashboardProfit.Equal,
                stat.value      = data.totalOrderCount
              }
            });
          }

          if (!this.statsGotTotalValidCount) {
            this.statsGotTotalValidCount=true;

            this.setButtonEnabledState();
            
            this.sureSimStatData.forEach((stat: DashboardStatistic) => {
              if (stat.title == "TOTAL VALID")
              {
                stat.loading    = false,
                stat.percentage = <string><unknown>0,
                stat.profit     = DashboardProfit.Equal,
                stat.value      = data.validOrderCount
              }
            });
          }

          if (!this.statsGotTotalInvalidCount) {
            this.statsGotTotalInvalidCount=true;
              
            this.sureSimStatData.forEach((stat: DashboardStatistic) => {
              if (stat.title == "TOTAL INVALID")
              {
                stat.loading    = false,
                stat.percentage = <string><unknown>0,
                stat.profit     = DashboardProfit.Equal,
                stat.value      = data.invalidOrderCount
              }
            });
          }

          if (!this.statsGotTotalProvisionedCount) {
            this.statsGotTotalProvisionedCount=true;
             
            this.sureSimStatData.forEach((stat: DashboardStatistic) => {
              if (stat.title == "TOTAL PROVISIONED")
              {
                stat.loading    = false,
                stat.percentage = <string><unknown>0,
                stat.profit     = DashboardProfit.Equal,
                stat.value      = data.completedOrderCount
              }
            });
          }

          if (!this.statsGotTotalErroredCount) {
            this.statsGotTotalErroredCount=true;
             
            this.sureSimStatData.forEach((stat: DashboardStatistic) => {
              if (stat.title == "TOTAL ERRORED")
              {
                stat.loading    = false,
                stat.percentage = "",
                stat.profit     = "",
                stat.value      = data.erroredOrderCount
              }
            });
          }

          if (!this.statsGotProvisioningProgress) {
            this.statsGotProvisioningProgress=true;
             
            this.sureSimStatData.forEach((stat: DashboardStatistic) => {
              if (stat.title == "PROVISIONING PROGRESS")
              {
                stat.loading    = false,
                stat.percentage = data.lastProcessingPercentage != null ? data.lastProcessingPercentage.toString() : "",
                stat.profit     = "",
                stat.value      = data.lastProcessingMessage,
                stat.showProfit = (data.lastProcessingPercentage != null ? data.lastProcessingPercentage.toString() : "")  != "",
                stat.showSpinner= data.lastProcessingMessage?.includes(processingKeyWordSearch)
              }
            });
          }

          if (data.lastProcessingMessage?.includes(processingKeyWordSearch) && this.statusObservable == undefined)
          {
            this.statusCheck = new ReplaySubject(1);
            this.statusObservable = timer(0, 10000);
            this.statusObservable.pipe(takeUntil(this.statusCheck)).subscribe(() => this.getBulkOrderStatus(true));
          } else if (!data.lastProcessingMessage?.includes(processingKeyWordSearch) &&  this.statusObservable != undefined) {
            this.statusCheck.next(true);
            this.statusCheck.complete();
            this.statusObservable = undefined; 
            this.pageheader.bulkOrderDropDownRefresh(this.filterCompanyID ?? -1, this.filterBulkOrderGuid); 
          }
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public validateBulkOrder() {
    try {
      if (this.gridView != null) {
      this.ordersService.validateBulkOrder(this.filterBulkOrderGuid)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          if (!this.statsGotTotalRequestCount) {
                this.getDashboardData();
          }
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  } 

  public refresh(autoRefresh:boolean = false) {
    this.setUploadMessagesVisible(false);
    this.statsGotProvisioningProgress =false;
    this.statsGotTotalErroredCount    =false;
    this.statsGotTotalInvalidCount    =false;
    this.statsGotTotalProvisionedCount=false;
    this.statsGotTotalRequestCount    =false;
    this.statsGotTotalValidCount      =false;
    this.uploadMessages               = [];
    this.validateBulkOrder();
    this.setDgApiPathGet(true);

    if (!autoRefresh) {
      this.resetStats();
    }
  }

  private resetStats() {
    try {
      if (this.sureSimStatData != undefined)
      {
        if (this.statsGotTotalRequestCount == false)
        {
          this.sureSimStatData.forEach((stat: DashboardStatistic) => {
            if (stat.title=="TOTAL ENTRIES")
            {
              stat.loading   =true,
              stat.percentage="",
              stat.profit    ="",
              stat.value     =0
            }
          });
        }
    
        if (this.statsGotTotalValidCount == false)
        {
          this.sureSimStatData.forEach((stat: DashboardStatistic) => {
            if (stat.title=="TOTAL VALID")
            {
              stat.loading   =true,
              stat.percentage="",
              stat.profit    ="",
              stat.value     =0
            }
          });
        }  
  
        if (this.statsGotTotalInvalidCount == false)
        {
          this.sureSimStatData.forEach((stat: DashboardStatistic) => {
            if (stat.title=="TOTAL INVALID")
            {
              stat.loading   =true,
              stat.percentage="",
              stat.profit    ="",
              stat.value     =0
            }
          });
        }
  
        if (this.statsGotTotalProvisionedCount == false)
        {
          this.sureSimStatData.forEach((stat: DashboardStatistic) => {
            if (stat.title=="TOTAL PROVISIONED")
            {
              stat.loading   =true,
              stat.percentage="",
              stat.profit    ="",
              stat.value     =0
            }
          });
        }

        if (this.statsGotTotalErroredCount == false)
        {
          this.sureSimStatData.forEach((stat: DashboardStatistic) => {
            if (stat.title=="TOTAL ERRORED")
            {
              stat.loading   =true,
              stat.percentage="",
              stat.profit    ="",
              stat.value     =0
            }
          });
        }

        if (this.statsGotProvisioningProgress == false)
        {
          this.sureSimStatData.forEach((stat: DashboardStatistic) => {
            if (stat.title=="PROVISIONING PROGRESS")
            {
              stat.loading   =true,
              stat.percentage="",
              stat.profit    ="",
              stat.value     =""
            }
          });
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }

  public progressCaption(stat: DashboardStatistic): string | undefined {
    try {
      const percent=this.progressPercent(stat);

      return percent===null ? undefined : percent + '% complete';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  public progressPercent(stat: DashboardStatistic): number | null {
    try {
      if (stat?.title!="PROVISIONING PROGRESS" || !stat.showProfit || stat.percentage==null || stat.percentage=="")
        return null;

      const percent=Number(stat.percentage);

      return Number.isFinite(percent) ? Math.min(Math.max(percent, 0), 100) : null;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return null;
    }
  }

  public get provisioningIsRunning(): boolean {
    return this.selectedBulkOrderSummary?.bulkOrderStatus == provisioningStatus;
  }

  public setButtonEnabledState() {
    let provisionstate = (this.selectedBulkOrderSummary != undefined && !this.provisioningIsRunning &&
                         (this.selectedBulkOrderSummary?.validOrderCount > 0 || this.selectedBulkOrderSummary?.erroredOrderCount > 0));
    this.provisionButtonEnabled = provisionstate;

    let deletestate = (this.selectedBulkOrderSummary != undefined && !this.provisioningIsRunning &&
                                                                     (this.selectedBulkOrderSummary?.validOrderCount > 0   ||
                                                                      this.selectedBulkOrderSummary?.invalidOrderCount > 0 ||
                                                                      this.selectedBulkOrderSummary?.erroredOrderCount > 0));
    this.deleteButtonEnabled = deletestate;
  }

  public onCheckboxChange(value: boolean | number | string): void {
    try {
      const on=value===true;

      this.dgProperties!.checkbox0!.value   =value;
      this.dgProperties!.columnHidingEnabled=!on;
      this.dgProperties!.columnMinWidth     =on ? this.columnMinWidth : undefined;

      this.gridView.setColumnHidingEnabled(!on);
      this.gridView.setColumnMinWidth(this.dgProperties!.columnMinWidth, this.dgActionColumn!.width);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onTabChange(event: any) {
    this.activeId = <number>event;
    // this.dgColumns.forEach((column: DgColumn) => {

	  // //   var columnVisibilityList = this.baseColumnList;
      
    // //   if (this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowId, false)) {
    // //     columnVisibilityList = columnVisibilityList.concat('id');
    // //   }

    // //   //Update column visibilty
    // //   if (this.activeId == this.navItemLog_Valid) {
    // //     columnVisibilityList = columnVisibilityList.concat([]);
    // //    } else if (this.activeId == this.navItemLog_Invalid) {
    // //     columnVisibilityList = columnVisibilityList.concat(["deprovisionedDate"]);
    // //    }

    // //    this.setColumnVisiability(columnVisibilityList);
    // });

    this.setDgApiPathGet(true);
    this.setButtonEnabledState();
  }

  public setColumnVisiability(visibleColumns: string[]) {
    this.dgColumns.forEach((column: DgColumn) =>
      {
        if (visibleColumns.indexOf(column.dataField) > -1) {
          column.gridVisible = true;
        }  
        else {
          column.gridVisible = false;
      } 
      });
  }
  
  public setDgApiPathGet(refreshdata:boolean) {
  try {
    var params ="?bulkOrderGuid=" + this.filterBulkOrderGuid + '&entryType=' + this.activeId;
    this.dgApiPath!.get=environment.eSimApi+eSimApiPaths.Orders + "/" + eSimApiPaths.OrdersBulk + params;
    this.gridViewService.apiPathGet=this.dgApiPath!.get;
    if (refreshdata == true && this.gridView != null) {
      this.gridView.refreshData();
    }
  
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  } 

  private setUpDgApiPaths() {
    try {
      this.dgApiPath     =this.gridViewDefaults.setUpDgApiPaths(apiPath); 
      this.dgApiPath!.get=environment.eSimApi+eSimApiPaths.Orders + "/" + eSimApiPaths.OrdersBulk + "?bulkOrderGuid=" + this.filterBulkOrderGuid + '&entryType=' + this.activeId;
      this.setDgApiPathGet(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgActionColumn() {
    try {
      this.dgActionColumn                          =this.gridViewDefaults.setUpDgActionColumn();
      this.dgActionColumn!.allowDeleting           =true;
      this.dgActionColumn!.allowMore               =true;
      this.dgActionColumn!.overrideDelete          =true;
      this.dgActionColumn!.cellTemplate            ="DataDrivenButtons";
      this.dgActionColumn!.deleteIcon              ="assets/images/_suresim/Button Delete 55x23.png";
      this.dgActionColumn!.deleteRowButtonCondition=(data:any) => {  
        let result = data.status == "Invalid" ||
                     data.status == "Errored" ||
                     data.status == "Valid";
        return result; 
      };
      this.dgActionColumn!.moreIcon                ="assets/images/_suresim/Provision Button 55x23.png";
      this.dgActionColumn!.moreRowButtonCondition=(data:any) => {  
        let result = data.status == "Errored" ||
                     data.status == "Valid";
        return result; 
      };
      this.dgActionColumn!.updateRowButtonCondition=(data:any) => {  
        let result = data.status == "Invalid" ||
                     data.status == "Errored" ||
                     data.status == "Valid";
        return result; 
      };
      this.dgActionColumn!.fixed         = true;
      this.dgActionColumn!.fixedPosition = "right";
      this.dgActionColumn!.width         = 188;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPopup() {
    try {
      this.dgPopup               =this.gridViewDefaults.setUpDgPopup(popUpTitle);
      this.dgPopup!.overridePopup=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgProperties() {
    try {
      const horizontalScrollOn                   =this.columnMinWidth > 0;
      this.dgProperties                          =this.gridViewDefaults.setUpDgProperties(mainTitle, exportFilenameSuffix);
      this.dgProperties!.autoNavigateToFocusedRow=false;
      //this.dgProperties!.cacheEnabled            =this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridCacheEnabled);   
      this.dgProperties!.checkbox0               =this.gridViewDefaults.setUpDgCheckbox("Horizontal Scroll & Fixed Columns",
                                                                                     true,
                                                                                     false,
                                                                                     horizontalScrollOn,
                                                                                     horizontalScrollOn);
      this.dgProperties!.columnHidingEnabled     =!horizontalScrollOn;
      this.dgProperties!.columnMinWidth          =horizontalScrollOn ? this.columnMinWidth : undefined;
      this.dgProperties!.gridKey                 ="EmbeddedSimProvisionBulk";
      this.dgProperties!.height                  =this.gridHeightForState();
      this.dgProperties!.initialTab              =this.navItemLog_All;
      this.dgProperties!.pageSize                =10;
      //this.dgProperties!.remoteOperations        =this.configSystemService.getValueAsBoolean(ConfigSystemParams.UseServerSidePaging);
      this.dgProperties!.showAddButton           =false;
      this.dgProperties!.showTabs                =true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e); 
    }
  }

  private setUpDgColumns() {
    try {
      let dgColumn: DgColumn | undefined;
      
      //ID
      dgColumn             =this.gridViewDefaults.setUpDgColumn("id", "ID", 0, DgColumnDataType.number);
      dgColumn!.formVisible=false;
      dgColumn!.gridVisible=this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowId, false);
      dgColumn!.width      =DgColumnWidths.id;
      dgColumn!.alignment  =DgAlignment.right;
      this.dgColumns       =[dgColumn!];

      //Sim Type
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("simType", "Sim Type", "", DgColumnDataType.datalist);
      dgColumn!.dataSource        =this.enumLookupDataSource(simTypeOptions);
      dgColumn!.dataSourceForAForm=of(simTypeOptions);
      dgColumn!.gridVisible       =true;
      dgColumn!.width             =77;
      dgColumn!.minWidth          =77;
      this.dgColumns.push(dgColumn!);

      //Use Type
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("isIOTDevice", "Use Type", false, DgColumnDataType.datalist);
      dgColumn!.dataSource        =this.enumLookupDataSource(useTypeOptions);
      dgColumn!.dataSourceForAForm=of(useTypeOptions);
      dgColumn!.gridVisible       =true;
      dgColumn!.width             =110;
      dgColumn!.minWidth          =110;
      this.dgColumns.push(dgColumn!);

      //Deployment Method
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("provisionType", "Deploy Method", "", DgColumnDataType.datalist);
      dgColumn!.dataSource        =this.enumLookupDataSource(provisionTypeOptions);
      dgColumn!.dataSourceForAForm=of(provisionTypeOptions);
      dgColumn!.gridVisible       =true;
      dgColumn!.width             =75;
      dgColumn!.minWidth          =75;
      this.dgColumns.push(dgColumn!);

      //Device OS
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("deviceOS", "Device OS", "", DgColumnDataType.datalist);
      dgColumn!.dataSource        =this.enumLookupDataSource(deviceOSOptions);
      dgColumn!.dataSourceForAForm=of(deviceOSOptions);
      dgColumn!.greyCellWhen      =greyDeviceOSCell;
      dgColumn!.greyCellTitle     =greyDeviceOSReason;
      dgColumn!.gridVisible       =true;
      dgColumn!.minWidth          =87;
      dgColumn!.width             =87;
      this.dgColumns.push(dgColumn!);

      //EID
      dgColumn               =this.gridViewDefaults.setUpDgColumn("eid", "EID", "", DgColumnDataType.string);
      dgColumn!.greyCellWhen =greyEidCell;
      dgColumn!.greyCellTitle=greyEidReason;
      dgColumn!.gridVisible  =true;
      dgColumn!.minWidth     =260;
      dgColumn!.width        =260;
      this.dgColumns.push(dgColumn!);

      //ICCID
      dgColumn               =this.gridViewDefaults.setUpDgColumn("iccid", "ICCID", "", DgColumnDataType.string);
      dgColumn!.greyCellWhen =greyIccidCell;
      dgColumn!.greyCellTitle=greyIccidReason;
      dgColumn!.gridVisible  =true;
      dgColumn!.minWidth     =170;
      dgColumn!.width        =170;
      this.dgColumns.push(dgColumn!);

      //SimRef
      dgColumn             =this.gridViewDefaults.setUpDgColumn("simRef", "SIM Ref", "", DgColumnDataType.string);
      dgColumn!.gridVisible=true;
      dgColumn!.width      =100;
      this.dgColumns.push(dgColumn!);

      //Product
      dgColumn             =this.gridViewDefaults.setUpDgColumn("product", "Product", "", DgColumnDataType.datalist);
      dgColumn!.gridVisible=true;
      dgColumn!.allowSearch=false;
      dgColumn!.calculateDisplayValue=(r: any) => abbreviateProduct(r?.product);
      dgColumn!.cellTitle             =(r: any) => r?.product;
      dgColumn!.dataSourceForAForm=this.productsService.getAvailableIdAndDescription();
      this.dgColumns.push(dgColumn!);

      //RBW_20260814 - Hidden, searchable column combining the original and abbreviated product text so the search box matches either (searchVisibleColumnsOnly is off)
      dgColumn                     =this.gridViewDefaults.setUpDgColumn("productSearch", "Product (search)", "", DgColumnDataType.string);
      dgColumn!.calculateCellValue =(r: any) => `${r?.product ?? ""} ${abbreviateProduct(r?.product)}`;
      dgColumn!.formVisible        =false;
      dgColumn!.gridVisible        =false;
      dgColumn!.showInColumnChooser=false;
      this.dgColumns.push(dgColumn!);

      //Firstname
      dgColumn             =this.gridViewDefaults.setUpDgColumn("firstname", "First Name/Location Id", "", DgColumnDataType.string);
      dgColumn!.gridVisible=true;
      dgColumn!.width      =175;
      this.dgColumns.push(dgColumn!);

      //Lastname
      dgColumn             =this.gridViewDefaults.setUpDgColumn("lastname", "Last Name/Asset Id", "", DgColumnDataType.string);
      dgColumn!.gridVisible=true;
      dgColumn!.width      =155;
      this.dgColumns.push(dgColumn!);      

      //Email
      dgColumn                       =this.gridViewDefaults.setUpDgColumn("email", "Email", "", DgColumnDataType.string);
      dgColumn!.greyCellWhen         =greyForIot;
      dgColumn!.greyCellTitle        =greyForIotReason;
      dgColumn!.gridVisible          =true;
      dgColumn!.minWidth             =200;
      dgColumn!.width                =200;
      this.dgColumns.push(dgColumn!);

      //Mobile
      dgColumn               =this.gridViewDefaults.setUpDgColumnMobile("mobile", "Mobile");
      dgColumn!.greyCellWhen =greyForIot;
      dgColumn!.greyCellTitle=greyForIotReason;
      dgColumn!.gridVisible  =true;
      dgColumn!.minWidth     =130;
      dgColumn!.width        =130;
      this.dgColumns.push(dgColumn!);

      //Tag
      dgColumn             =this.gridViewDefaults.setUpDgColumn("tag", "User Ref 1", "", DgColumnDataType.string);
      dgColumn!.gridVisible=true;
      dgColumn!.width      =100;
      this.dgColumns.push(dgColumn!);

      //Tag2
      dgColumn             =this.gridViewDefaults.setUpDgColumn("tag2", "User Ref 2", "", DgColumnDataType.string);
      dgColumn!.gridVisible=true;
      dgColumn!.width      =100;
      this.dgColumns.push(dgColumn!);

      if (this.showCostCentres) {
        //CostCentre2
        dgColumn                    =this.gridViewDefaults.setUpDgColumn("costCentre2", "Cost Centre L2", "", DgColumnDataType.datalist);
        dgColumn!.dataSourceForAForm=this.inviewCostCentresService.getIdAndDescription_Lv2(<number>this.filterInviewCompanyID ?? -1)
        dgColumn!.greyCellWhen      =greyForIot;
        dgColumn!.greyCellTitle     =greyForIotReason;
        dgColumn!.gridVisible       =true;
        dgColumn!.width             =120;
        this.dgColumns.push(dgColumn!);

        //CostCentre
        dgColumn                    =this.gridViewDefaults.setUpDgColumn("costCentre", "Cost Centre L1", "", DgColumnDataType.datalist);
        dgColumn!.dataSourceForAForm=this.inviewCostCentresService.getIdAndDescription_Lv1(<number>this.filterInviewCompanyID ?? -1, <number>this.selectedInviewCostCentreLv2?.id ?? -1)
        dgColumn!.greyCellWhen      =greyForIot;
        dgColumn!.greyCellTitle     =greyForIotReason;      
        dgColumn!.gridVisible       =true;
        dgColumn!.width             =120;
        this.dgColumns.push(dgColumn!);
      }

      dgColumn                    =this.gridViewDefaults.setUpDgColumn("inheritCompanyLimit", "Inherit Limit", true, DgColumnDataType.boolean);
      dgColumn!.dataSource        =this.booleanService.idAndDescriptionLookupDataSource();
      dgColumn!.dataSourceForAForm=this.booleanService.getIdAndDescription();
      dgColumn!.gridVisible       =true;
      dgColumn!.width             =90;
      dgColumn!.minWidth          =90;
      this.dgColumns.push(dgColumn!);

      //Limit 
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("limit", "Limit", "", DgColumnDataType.string);
      dgColumn!.greyCellWhen      =greyLimitTypeCell;
      dgColumn!.greyCellTitle     =greyLimitReason;
      dgColumn!.gridVisible       =true;
      dgColumn!.minWidth          =90;
      dgColumn!.width             =110;
      dgColumn!.alignment         =DgAlignment.right;
      dgColumn!.calculateDisplayValue=(r: any) => this.limitDisplay(r);
      dgColumn!.validationFields  =["limitType", "limitAmount", "dataWeightCode"];
      this.dgColumns.push(dgColumn!);

      //Activation server
      dgColumn             =this.gridViewDefaults.setUpDgColumn("activationServer", "Activation Server", "", DgColumnDataType.string);
      dgColumn!.greyCellWhen=greyActivationCell;
      dgColumn!.greyCellTitle=greyActivationReason;
      dgColumn!.gridVisible=true;
      this.dgColumns.push(dgColumn!);

      //Activation Code
      dgColumn               =this.gridViewDefaults.setUpDgColumn("activationCode", "Activation Code", "", DgColumnDataType.string);
      dgColumn!.greyCellWhen =greyActivationCell;
      dgColumn!.greyCellTitle=greyActivationReason;
      dgColumn!.gridVisible   =true;
      this.dgColumns.push(dgColumn!);

      //UserID
      dgColumn                  =this.gridViewDefaults.setUpDgColumn("userID", "User ID", "", DgColumnDataType.number);
      dgColumn!.formVisible     =false;
      dgColumn!.gridVisible     =false;
      this.dgColumns.push(dgColumn!);

      //OrderID
      dgColumn                  =this.gridViewDefaults.setUpDgColumn("orderID", "Order ID", "", DgColumnDataType.number);
      dgColumn!.formVisible     =false;
      dgColumn!.gridVisible     =false;
      this.dgColumns.push(dgColumn!);

      //OrderNo
      dgColumn                  =this.gridViewDefaults.setUpDgColumn("orderNo", "Order No", "", DgColumnDataType.string);
      dgColumn!.alignment       =DgAlignment.right;
      dgColumn!.cellTemplate    ="OrderIDTemplate";
      dgColumn!.cellTemplateType="link"
      dgColumn!.formVisible     =false;
      dgColumn!.width           =105;
      this.dgColumns.push(dgColumn!);

      //UserStatus
      dgColumn                       =this.gridViewDefaults.setUpDgColumn("userStatus", "User Found", "", DgColumnDataType.string);
      dgColumn!.cellTemplate         ="UserStatusTemplate";
      dgColumn!.cellTemplateCondition=(data:any) => {
        let result = data.userID != null;
        return result;
      };
      dgColumn!.cellTemplateType     ="link"
      dgColumn!.formVisible          =false;
      dgColumn!.fixed                =true;
      dgColumn!.fixedPosition        ="right";
      dgColumn!.gridVisible          =true;
      dgColumn!.minWidth             =210;
      dgColumn!.width                =225;
      this.dgColumns.push(dgColumn!);

      //Status
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("status", "Status", "", DgColumnDataType.string);
      dgColumn!.fixed             =true;
      dgColumn!.fixedPosition     ="right";
      dgColumn!.formVisible       =false;
      dgColumn!.minWidth          =100;
      dgColumn!.width             =110;
      this.dgColumns.push(dgColumn!);

      //validationFailed
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("validationFailed", "Invalid", "", DgColumnDataType.boolean);
      dgColumn!.formVisible       =false;
      dgColumn!.gridVisible       =false;
      dgColumn!.width             =80;
      this.dgColumns.push(dgColumn!);

      //Active
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("active", "Active", true, DgColumnDataType.boolean);
      dgColumn!.dataSource        =this.booleanService.idAndDescriptionLookupDataSource();
      dgColumn!.dataSourceForAForm=this.booleanService.getIdAndDescription();
      dgColumn!.formVisible       =false;
      dgColumn!.gridVisible       =false;
      dgColumn!.validators        =[Validators.required];
      this.dgColumns.push(dgColumn!);

      //EnteredByName
      dgColumn             =this.gridViewDefaults.setUpDgColumn("enteredByName", "Entered By", this.curUserID, DgColumnDataType.string);
      dgColumn!.formVisible=false;
      dgColumn!.gridVisible=false;
      this.dgColumns.push(dgColumn!);

      //EnteredDate
      dgColumn             =this.gridViewDefaults.setUpDgColumn("enteredDate", "Entered Date", "", DgColumnDataType.datetime);
      dgColumn!.formVisible=false;
      dgColumn!.gridVisible=false;
      dgColumn!.sendToDB   =false;
      this.dgColumns.push(dgColumn!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private limitDisplay(r: any): string {
    try {
      if (r?.inheritCompanyLimit === true)
        return "";

      if (r?.limitType === LimitType.Off)
        return "Off";

      const amount    = r?.limitAmount;
      const hasAmount = amount != null && amount !== "" && !isNaN(Number(amount));

      if (r?.limitType === LimitType.Spend)
        return hasAmount ? `${this.companyCurrencySymbol}${Number(amount).toFixed(2)}` : "";

      if (r?.limitType === LimitType.Data)
        return `${hasAmount ? Number(amount) : ""} ${r?.dataWeightCode ?? ""}`.trim();

      return "";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  //RBW_20260604 - Builds a DevExtreme lookup data source from a static id/description list (mirrors BooleanService)
  private enumLookupDataSource(values: IdAndDescriptionDTO[]): {} {
    try {
      return {
        store: new CustomStore({
          key     : "id",
          loadMode: "raw",
          load    : () => lastValueFrom(of(values))
        }),
        sort: "description"
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }

  private setUpDgTabs() {
    try {
      let dgTab: DgTab | undefined;
      
      //All
      dgTab             =this.gridViewDefaults.setUpDgTab(this.navItemLog_All, "All");
      this.dgTabs       =[dgTab!];

      //Valid
      dgTab             =this.gridViewDefaults.setUpDgTab(this.navItemLog_Valid, "Valid");
      this.dgTabs.push(dgTab!);

      //Invalid
      dgTab             =this.gridViewDefaults.setUpDgTab(this.navItemLog_Invalid, "Invalid");
      this.dgTabs.push(dgTab!);

      //Provisioned
      dgTab             =this.gridViewDefaults.setUpDgTab(this.navItemLog_Provisioned, "Provisioned");
      this.dgTabs.push(dgTab!);

      //Errored
      dgTab             =this.gridViewDefaults.setUpDgTab(this.navItemLog_Errored, "Errored");
      this.dgTabs.push(dgTab!);

      //InProgress
      dgTab             =this.gridViewDefaults.setUpDgTab(this.navItemLog_InProgress, "In Progress");
      this.dgTabs.push(dgTab!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public cellClick(e : any)
  {
    try {
      if (e != undefined)
      {
        if (e.column.name == "userStatus") {
          this.gridUserLinkClick.emit(Number(e.row.data["userID"]));
        } 
  
        if (e.column.name == "orderNo" && e.row.data["orderID"] != null) {
          this.gridOrderLinkClick.emit(Number(e.row.data["orderID"]));
        } 
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public gridAddButtonClick(e:any) {
    try {
      // if (!this.manageEsimFormIsOpen) {
      //   this.manageEsimFormIsOpen=true;
      //   this.manageEsimModalForm.openForm(0);
      // }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public confirmBulkDelete() {
    try {
      const toDelete = (this.selectedBulkOrderSummary?.totalOrderCount ?? 0) - (this.selectedBulkOrderSummary?.completedOrderCount ?? 0);

      this.deleteBulkConfirmationModal.openForm("WARNING",
                                                `This will delete all ${toDelete} non provisioned ${toDelete == 1 ? "entry" : "entries"} in this bulk order, not just the rows currently shown. Are you sure?`,
                                                undefined,
                                                OurColors.Red,
                                                OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public confirmDelete(e:any) {
    try {
      this.selectedRowData            = e.row.data;
      let orderId: number | undefined = this.selectedRowData.id;
      let email  : string             = this.selectedRowData.email ?? "";
    
      if (orderId==undefined || <number>orderId<=0) {
        throw new Error("SimProvisionBulkEmbeddedComponent..SureSIM OrderID cannot be determined");
      }

      this.deleteConfirmationModal.openForm("WARNING",
                                            `Are you sure you want to delete bulk order details for ${email} ?`,
                                            undefined,
                                            OurColors.Red,
                                            OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridEditClick(e:any) {
    try {
      let orderId: number | undefined = e.row.data["id"];
      let validationMessages: string[] = e.row.data["validationMessages"] ?? [];
      let userExists: boolean = (e.row.data["userID"] ?? -1) > 0;
    
      if (orderId==undefined || <number>orderId<=0) {
        throw new Error("SimProvisionBulkEmbeddedComponent..SureSIM OrderID cannot be determined");
      }
      
      this.gridEditRowClick.emit({orderGuid:this.filterBulkOrderGuid,orderId:orderId,validationMessages:validationMessages, userExists});
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridMoreClick(e:any) {
    try {
      let orderId: number | undefined = e.row.data["id"];
    
      if (orderId==undefined || <number>orderId<=0) {
        throw new Error("SimProvisionBulkEmbeddedComponent..SureSIM OrderID cannot be determined");
      }
      
      this.doProvisioning(this.filterBulkOrderGuid, orderId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridRowClick(e:any) {
    try {
      this.selectedRowData = this.gridView.dataGrid.instance.getSelectedRowsData()[0];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public BulkProvisionButtonClick() {
    try {
      const toProvision = this.selectedBulkOrderSummary?.validOrderCount ?? 0;

      this.provisionBulkConfirmationModal.openForm("WARNING",
                                                   `This will provision all ${toProvision} valid ${toProvision == 1 ? "entry" : "entries"} in this bulk order, not just the rows currently shown. Are you sure?`,
                                                   undefined,
                                                   OurColors.Red,
                                                   OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public StopProvisioningButtonClick() {
    try {
      this.devicesService.stopBulkProvisioning(this.filterBulkOrderGuid)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          const stopped = data?.result ?? 0;

          this.refresh();
          this.getBulkOrderSummary();

          this.completedModalForm.openForm("Provisioning Stopped",
                                           stopped == 0
                                           ? "There were no remaining entries to stop"
                                           : `${stopped} ${stopped == 1 ? "entry has" : "entries have"} been stood down. Any entry already being provisioned will still complete.`);
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public yesBulkProvision() {
    try {
      this.provisionButtonEnabled = false;
      this.bulkProvisionButtonClick.emit();
      this.doProvisioning(this.filterBulkOrderGuid);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public CreateTemplateButtonClick() {
    try {
      this.exportToExcel();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public BulkDeleteButtonClick() {
    try {
      this.confirmBulkDelete();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public get updateInviewButtonVisible(): boolean {
    return (this.activeId == this.navItemLog_All || this.activeId == this.navItemLog_Invalid) && this.updateInviewCount > 0 &&
           this.componentAccessUserService.hasAccessGuid(AccessGuids.FormProvisionBulkRetireInviewClisButton, true);
  }

  public get createUsersButtonVisible(): boolean {
    return (this.activeId == this.navItemLog_All || this.activeId == this.navItemLog_Valid) && this.createUsersCount > 0 &&
           this.componentAccessUserService.hasAccessGuid(AccessGuids.FormProvisionBulkCreateUsersButton, true);
  }

  public get reserveSimsButtonVisible(): boolean {
    return this.reserveSimsCount > 0 &&
           this.componentAccessUserService.hasAccessGuid(AccessGuids.FormProvisionBulkReserveSimsButton, true);
  }

  public get sendManualActivationButtonVisible(): boolean {
    return this.manualActivationCount > 0;
  }

  public get bulkDeleteCount(): number {
    return (this.selectedBulkOrderSummary?.totalOrderCount ?? 0) - (this.selectedBulkOrderSummary?.completedOrderCount ?? 0);
  }

  public get bulkProvisionCount(): number {
    return this.selectedBulkOrderSummary?.validOrderCount ?? 0;
  }

  public get bulkClearErrorsCount(): number {
    return this.selectedBulkOrderSummary?.erroredOrderCount ?? 0;
  }

  public get clearErrorsButtonVisible(): boolean {
    return this.bulkClearErrorsCount > 0;
  }

  public gridContentReady(e:any) {
    try {
      const rows = <any[]>(this.gridView?.clientSideProcessingModels ?? []);

      this.updateInviewCount = rows.filter(row => row?.inviewCliHeldByUserID != null).length;
      this.createUsersCount  = rows.filter(row => row?.validationFailed != true &&
                                                  row?.completedDate == null &&
                                                  row?.userID == null &&
                                                  !((row?.userStatus ?? "") as string).includes("Other Co.")).length;
      this.reserveSimsCount  = rows.filter(row => row?.iccidReservable == true).length;
      this.manualActivationCount = rows.filter(row => row?.provisionType == DeviceActivationType.SendViaManual &&
                                                      row?.completedDate != null &&
                                                      (row?.activationCode ?? "") != "").length;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public UpdateInviewToMatchButtonClick() {
    try {
      this.updateInviewConfirmationModal.openForm("WARNING",
                                                 `This will retire ${this.updateInviewCount} Inview mobile ${this.updateInviewCount == 1 ? "entry" : "entries"} held against a different user in this company, so the numbers can be registered against the users in this bulk order. This covers the whole bulk order, not just the rows currently shown. Are you sure?`,
                                                 undefined,
                                                 OurColors.Red,
                                                 OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public yesUpdateInviewToMatch() {
    try {
      this.uploadInProgress = true;

      this.devicesService.bulkUpdateInviewToMatch(this.filterBulkOrderGuid)
      .pipe(
        catchError((error) => {
          this.uploadInProgress = false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.uploadInProgress = false;
          const retired        = data?.result ?? 0;

          this.refresh();
          this.getBulkOrderSummary();

          this.completedModalForm.openForm("Inview Updated",
                                           retired == 0
                                           ? "No Inview mobile entries needed updating"
                                           : `${retired} Inview mobile ${retired == 1 ? "entry" : "entries"} retired. These rows can now be provisioned.`);
        },
        error: error => {
          this.uploadInProgress = false;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.uploadInProgress = false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public CreateUsersOnlyButtonClick() {
    try {
      this.createUsersConfirmationModal.openForm("WARNING",
                                                 `This will create ${this.createUsersCount} user ${this.createUsersCount == 1 ? "record" : "records"} for the valid rows that don't yet have a user, without provisioning any SIMs. This covers the whole bulk order, not just the rows currently shown. Are you sure?`,
                                                 undefined,
                                                 OurColors.Red,
                                                 OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public yesCreateUsersOnly() {
    try {
      this.uploadInProgress = true;

      this.devicesService.bulkCreateUsersOnly(this.filterBulkOrderGuid)
      .pipe(
        catchError((error) => {
          this.uploadInProgress = false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.uploadInProgress = false;
          const created        = data?.result ?? 0;

          this.refresh();
          this.getBulkOrderSummary();

          this.completedModalForm.openForm("Users Created",
                                           created == 0
                                           ? "No users needed creating"
                                           : `${created} user ${created == 1 ? "record" : "records"} created. These rows can now be provisioned.`);
        },
        error: error => {
          this.uploadInProgress = false;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.uploadInProgress = false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ReserveSimsButtonClick() {
    try {
      this.reserveSimsConfirmationModal.openForm("WARNING",
                                                 `This will reserve ${this.reserveSimsCount} physical SIM ${this.reserveSimsCount == 1 ? "ICCID" : "ICCIDs"} to this company so they can be provisioned. This covers the whole bulk order, not just the rows currently shown. Are you sure?`,
                                                 undefined,
                                                 OurColors.Red,
                                                 OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public yesReserveSims() {
    try {
      this.uploadInProgress = true;

      this.devicesService.bulkReserveSims(this.filterBulkOrderGuid)
      .pipe(
        catchError((error) => {
          this.uploadInProgress = false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.uploadInProgress = false;
          const reserved       = data?.result ?? 0;

          this.refresh();
          this.getBulkOrderSummary();

          this.completedModalForm.openForm("SIMs Reserved",
                                           reserved == 0
                                           ? "No SIMs needed reserving"
                                           : `${reserved} SIM ${reserved == 1 ? "ICCID" : "ICCIDs"} reserved. These rows can now be provisioned.`);
        },
        error: error => {
          this.uploadInProgress = false;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.uploadInProgress = false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ClearErrorsButtonClick() {
    try {
      this.clearErrorsConfirmationModal.openForm("WARNING",
                                                 `This will clear the error on ${this.bulkClearErrorsCount} errored ${this.bulkClearErrorsCount == 1 ? "row" : "rows"} so they can be provisioned again by the next Bulk Provision. This covers the whole bulk order, not just the rows currently shown. Are you sure?`,
                                                 undefined,
                                                 OurColors.Red,
                                                 OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public yesClearErrors() {
    try {
      this.uploadInProgress = true;

      this.devicesService.bulkClearErrors(this.filterBulkOrderGuid)
      .pipe(
        catchError((error) => {
          this.uploadInProgress = false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.uploadInProgress = false;
          const cleared        = data?.result ?? 0;

          this.refresh();
          this.getBulkOrderSummary();

          this.completedModalForm.openForm("Errors Cleared",
                                           cleared == 0
                                           ? "No errored rows needed clearing"
                                           : `${cleared} errored ${cleared == 1 ? "row" : "rows"} cleared. These rows can now be provisioned again.`);
        },
        error: error => {
          this.uploadInProgress = false;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.uploadInProgress = false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public SendManualActivationButtonClick() {
    try {
      this.sendManualConfirmationModal.openForm("Send Manual Activation Details",
                                                `This will email you (the logged-in user) one message containing the activation server and code for the ${this.manualActivationCount} manually-provisioned SIM ${this.manualActivationCount == 1 ? "entry" : "entries"} in this bulk order. Are you sure?`,
                                                undefined,
                                                OurColors.Red,
                                                OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public yesSendManualActivation() {
    try {
      this.uploadInProgress = true;

      this.devicesService.sendManualActivationDetails(this.filterBulkOrderGuid)
      .pipe(
        catchError((error) => {
          this.uploadInProgress = false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.uploadInProgress = false;
          const sent           = data?.result ?? 0;

          this.completedModalForm.openForm("Manual Activation Details",
                                           sent == 0
                                           ? "No manual activation details to send"
                                           : `Emailed you the activation details for ${sent} manually-provisioned SIM ${sent == 1 ? "entry" : "entries"}.`);
        },
        error: error => {
          this.uploadInProgress = false;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.uploadInProgress = false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private doProvisioning(bulkOrderGuid : string, orderID : number | undefined = undefined): void {
    try {
      this.provisioningInProgress = true;

      this.devicesService.bulkProvisionInitialise(bulkOrderGuid, orderID)
      .pipe(
        catchError((error) => {
          this.provisioningInProgress = false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.pageheader.bulkOrderDropDownRefresh(this.filterCompanyID ?? -1, this.filterBulkOrderGuid); 
          this.getBulkOrderSummary();
          this.doBulkProvisioning(bulkOrderGuid, data);
        },
        error: error => {
          if (error.message && error.message.includes("404")) {
            this.provisioningInProgress = false;
            // this.enableDisableControls(false);

            // this.warningMessageMain="There are no eSIMs available";
            // this.warningMessageSub ="Please contact the application vendor for assistance";

            // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
          } else {
            this.provisioningInProgress = false;
            this.exceptionsService.handleException(new Error(error));
          }
        }
      });
    }
    catch(e) {
      this.provisioningInProgress = false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private doBulkProvisioning(bulkOrderGuid : string, processDate : Date): void {
    try {
      this.devicesService.bulkProvision(bulkOrderGuid, processDate)
      .pipe(
        catchError((error) => {
          this.provisioningInProgress = false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.provisioningInProgress = false;
        },
        error: error => {
          if (error.message && error.message.includes("404")) {
            this.provisioningInProgress = false;
            // this.enableDisableControls(false);

            // this.warningMessageMain="There are no eSIMs available";
            // this.warningMessageSub ="Please contact the application vendor for assistance";

            // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
          } else {
            this.provisioningInProgress = false;
            this.exceptionsService.handleException(new Error(error));
          }
        }
      });
    }
    catch(e) {
      this.provisioningInProgress = false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getBulkOrderStatus(autoRefresh:boolean = false) {
    try {
      this.refresh(autoRefresh);
    }
    catch(e) {
      //this.provisioningInProgress = false;
      this.exceptionsService.handleException(<Error>e);
    }
  }  

  public hideUploadMessagesButtonClick() {
    this.setUploadMessagesVisible(false);
  }

  private setUploadMessagesVisible(visible: boolean): void {
    this.showUploadMessages = visible;
    this.updateGridHeight();
  }

  public toggleInstructions(): void {
    this.instructionsCollapsed = !this.instructionsCollapsed;
    this.updateGridHeight();
  }

  private updateGridHeight(): void {
    if (this.dgProperties)
      this.dgProperties.height = this.gridHeightForState();
  }

  private gridHeightForState(): string {
    const instructionsOffset = this.instructionsCollapsed ? 105 : 190;
    const messagesOffset     = this.showUploadMessages ? 190 : 0;

    return `calc(100vh - ${310 + instructionsOffset + messagesOffset + this.extraGridHeightOffset}px)`;
  }

  public companyDropDownOnChange(companyID: number) {
    this.curUserCompanyID    = companyID;
    this.filterCompanyID     = companyID;
    this.filterBulkOrderGuid = crypto.randomUUID();
    this.pageheader.bulkOrderDropDownRefresh(companyID, this.filterBulkOrderGuid);
    this.companyIdChanged.emit(companyID); //RBW_20260604 - Notify wrapper so it can refresh the company-scoped SMS/Email templates
    this.refresh();

    // this.deviceSelector.companyId = companyID;
    // this.userSelector.companyId   = companyID;
    // this.userSelector.refreshData();
    // this.deviceSelector.refreshData();
    // let showgrid = ((this.curReportID ?? -1) > -1 && (this.curReportDateID ?? -1) > -1);
    // this.setDgApiPathGet(showgrid);

    this.getInviewCompanyId();
  }

  public closeForm(): void {
    try {
      this.statusCheck.next(true);
      this.statusCheck.complete();
      this.statusObservable = undefined;
      this.formClosed.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //RBW_20260604 - Cog menu: delegate to the wrapper so the template modals (in FormsModalModule) can be opened without a circular module dependency
  public onViewEmailTemplateClick(): void {
    try {
      this.viewEmailTemplateClick.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onViewSmsTemplateClick(): void {
    try {
      this.viewSmsTemplateClick.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getInviewCompanyId() {
    try {
      if (this.filterCompanyID != undefined && this.filterCompanyID>0) {

        this.companiesService.getById(this.filterCompanyID)
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              this.filterInviewCompanyID  =data.inviewCompanyID;
              this.companyCurrencySymbol  =data.invoiceCurrencySymbol ?? "£";
             },
             error: error => {
               this.exceptionsService.handleException(new Error(error));
            }
           });
        } else {
          this.filterInviewCompanyID=this.filterCompanyID;
          this.companyCurrencySymbol="£";
        }
      }
      catch(e) {
        this.exceptionsService.handleException(<Error>e);
        return (undefined);
    }
  }

  public UploadTemplateButtonClick() {
    try {
      this.filterBulkOrderGuid = crypto.randomUUID();
      this.pageheader.bulkOrderDropDownRefresh(this.filterCompanyID ?? -1, this.filterBulkOrderGuid);
      var fi = this.fileInput.nativeElement as HTMLInputElement;
      fi.value = ''; // Reset the value
      //this.resetFileInput();
      fi.click();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public bulkOrderDropDownOnChange(bulkOrderGuid: string) {
    this.noBulkOrderSelected = bulkOrderGuid == "";

    if (bulkOrderGuid != "") {
      this.filterBulkOrderGuid = bulkOrderGuid;
    } else {
      this.filterBulkOrderGuid = crypto.randomUUID();
    }

    this.refresh();
  }

  public uploadData(event: any) : void { 
    try {
    // get data from file upload       
    let filesData = event.target;//.files[0];
    let arrayBuffer:any;

    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(filesData);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    this.selectedFile = target.files[0].name;
    const reader: FileReader = new FileReader();
    reader.readAsArrayBuffer(target.files[0]);

    reader.onload = (e: any) => {
      /* create workbook */
      const binarystr: string = [...new Uint8Array(e.target.result)]
                                .map(v => String.fromCharCode(v)).join('');

      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

      /* selected the first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      const rawRows: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "" });
      const headerRowIdx     = rawRows.findIndex(r => Array.isArray(r) && r.some(cell => (cell ?? "").toString().trim() === "Sim Type"));
      const data             = XLSX.utils.sheet_to_json(ws, { defval: "", range: headerRowIdx >= 0 ? headerRowIdx : 0 });

      //RBW_20260914 - Strip line breaks.
      (<any[]>data).forEach(row =>
        Object.keys(row).forEach(key => {
          if (typeof row[key] === "string")
            row[key] = row[key].replace(/[\r\n]/g, "").trim();
        }));

      let validationMessages = this.validateFileData(data);

      if (validationMessages.length == 0)
      {
        const dataRows = (<any[]>data).filter(row =>
          Object.keys(row).some(key => key !== "Inherit Company Limit" && (row[key] ?? "").toString().trim() !== ""));

        if (dataRows.length === 0) {
          this.uploadTitle    = 'Upload Error';
          this.uploadMessages = ['No rows with data were found in the template.'];
          this.setUploadMessagesVisible(true);
          return;
        }

        dataRows.forEach(row => {
                      row = this.renameProperty(row, "First Name/Location Id", "Firstname");
                      row = this.renameProperty(row, "Last Name/Asset Id"   , "Lastname");
                      row = this.renameProperty(row, "First Name", "Firstname"); //RBW_20260604 - kept for templates downloaded before the header change
                      row = this.renameProperty(row, "Last Name" , "Lastname");
                      row = this.renameProperty(row, "User Ref 1" , "Tag");
                      row = this.renameProperty(row, "User Ref 2" , "Tag2");
                      row = this.renameProperty(row, "SIM Ref" , "SimRef");
                      row = this.renameProperty(row, "User Tag" , "Tag"); //RBW_20260730 - kept for templates downloaded before the header change
                      row = this.renameProperty(row, "Cost Centre" , "CostCentre");
                      row = this.renameProperty(row, "Cost Centre 2" , "CostCentre2");
                      row = this.addProperty(row, "CompanyID", this.filterCompanyID?.toString() ?? "");
                      row = this.addProperty(row, "BulkOrderGuid", this.filterBulkOrderGuid?.toString() ?? "");
                      row = this.addProperty(row, "FileName", this.selectedFile ?? "");
                      row = this.mapProvisioningExtras(row);
                    });
  
        this.uploadInProgress = true;

        this.UploadBulkOrders(dataRows);
      } else {
        this.uploadTitle = 'Upload Error';
        this.uploadMessages =[];
        this.uploadMessages.push(...validationMessages);
        this.setUploadMessagesVisible(true);
      }

      //console.log(data); // Data will be logged in array format containing objects
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public addProperty(obj: any, newProp: string, value: string): any {
    if (!obj.hasOwnProperty(newProp)) {
      obj[newProp] = value;
    }
    return obj;
  }

  public renameProperty(obj: any, oldProp: string, newProp: string): any {
    if (obj.hasOwnProperty(oldProp)) {
      obj[newProp] = obj[oldProp];
      delete obj[oldProp];
    }
    return obj;
  }

  private resolveAlpha2FromCountryText(countryCodeText: string, dialCodeDigits: string): string | undefined {
    try {
      if (this.countriesCache.length === 0)
        return undefined;

      const nameOnly = countryCodeText.replace(/\s*\(\+?\d+\)\s*$/, "").trim().toLowerCase();

      let match = nameOnly === ""
                  ? undefined
                  : this.countriesCache.find(c => (c.countryName ?? "").trim().toLowerCase() === nameOnly);

      if (!match && dialCodeDigits !== "")
        match = this.countriesCache.find(c => this.phoneNumberService.toDigits(c.diallingCode) === dialCodeDigits);

      return match?.alpha2Code;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  //RBW_20260604 - Convert the new bulk template columns (display text) into the enum ids / boolean the backend expects
  private mapProvisioningExtras(row: any): any {
    try {
      //RBW_20260604 - Map to the enum id; an unrecognised/blank value becomes 0 (Unknown) so the backend flags the row invalid instead of silently defaulting
      const provisionTypeText = (row["Deploy Method"] ?? row["Deployment Method"] ?? row["Provision Type"] ?? "").toString().trim().toLowerCase();
      row["ProvisionType"]    = provisionTypeText.includes("email")  ? DeviceActivationType.SendViaEmail
                              : provisionTypeText.includes("sms")    ? DeviceActivationType.SendViaSMS
                              : provisionTypeText.includes("manual") ? DeviceActivationType.SendViaManual
                              : provisionTypeText.includes("iccid")  ? DeviceActivationType.PushViaICCID
                              : provisionTypeText.includes("eid")    ? DeviceActivationType.PushViaEID
                              : 0;

      const simTypeText = (row["Sim Type"] ?? "").toString().trim().toLowerCase();
      row["SimType"]    = simTypeText === "esim" ? eDeviceType.esim
                        : simTypeText === "sim"  ? eDeviceType.sim
                        : eDeviceType.unknown;

      const deviceOSText = (row["Device OS"] ?? "").toString().trim().toLowerCase();
      row["DeviceOS"]    = deviceOSText.startsWith("android") ? DeviceOSType.Android
                         : deviceOSText.startsWith("windows") ? DeviceOSType.Windows
                         : deviceOSText.startsWith("apple")   ? DeviceOSType.AppleIOS
                         : 0;

      const useTypeText  = (row["Use Type"] ?? row["IsIOTDevice"] ?? "").toString().trim().toLowerCase();
      row["IsIOTDevice"] = (useTypeText.includes("iot") || useTypeText === "yes" || useTypeText === "true" || useTypeText === "y" || useTypeText === "1");
      delete row["Use Type"];

      if (this.useInternationalDialCode && row["IsIOTDevice"] !== true) {
        const countryCodeText = (row["Country Code"] ?? "").toString().trim();
        const mobileRaw       = (row["Mobile"] ?? "").toString().trim();
        const parenMatch      = countryCodeText.match(/\(\+?(\d+)\)/);
        const dialCodeDigits  = parenMatch ? parenMatch[1] : this.phoneNumberService.toDigits(countryCodeText);
        const dialCode        = dialCodeDigits === "" ? "" : "+" + dialCodeDigits;

        row["MobileIntCode"] = dialCode;

        const alpha2Code = this.resolveAlpha2FromCountryText(countryCodeText, dialCodeDigits);

        if (dialCode !== "" && mobileRaw !== "") {
          const result = this.phoneNumberService.validateAgainstDialCode(mobileRaw, dialCode, alpha2Code);

          if (result.isValid) {
            row["Mobile"]     = "0" + result.nationalNumber;
            row["MobileE164"] = result.e164;
          } else {
            row["MobileE164"] = "";
          }
        } else {
          row["MobileE164"] = "";
        }
      }
      delete row["Country Code"];

      const inheritText = (row["Inherit Company Limit"] ?? "").toString().trim().toLowerCase();
      row["InheritCompanyLimit"] = !(inheritText === "no" || inheritText === "false" || inheritText === "n");

      const limitTypeText = (row["Limit Type"] ?? "").toString().trim().toLowerCase();
      row["LimitType"]    = limitTypeText.includes("data")  ? LimitType.Data
                          : limitTypeText.includes("spend") ? LimitType.Spend
                          : (limitTypeText.includes("no limit") || limitTypeText === "off" || limitTypeText === "none") ? LimitType.Off
                          : null;

      const limitAmountText = (row["Limit Amount"] ?? "").toString().trim();
      row["LimitAmount"]    = limitAmountText === "" ? null : Number(limitAmountText);

      row["DataWeightCode"] = (row["Limit Data Weight"] ?? row["Data Weight"] ?? "").toString().trim();

      delete row["Deploy Method"];
      delete row["Deployment Method"];
      delete row["Provision Type"];
      delete row["Sim Type"];
      delete row["Device OS"];
      delete row["Inherit Company Limit"];
      delete row["Limit Type"];
      delete row["Limit Amount"];
      delete row["Limit Data Weight"];
      delete row["Data Weight"];

      return row;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return row;
    }
  }

  public UploadBulkOrders(bulkOrders : any[]) {
    this.ordersService.UploadBulkOrders(bulkOrders)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.uploadInProgress = false;

          let errorText = '';
          if (data.uploadValidationMessages?.length > 0) {
            errorText = ', some data was too long so was truncated, details availble after closing this popup.';
          }

          this.completedModalForm.openForm("Upload Complete", `Order details from file ${this.selectedFile} added${errorText}`);

          this.pageheader.bulkOrderDropDownRefresh(this.filterCompanyID ?? -1, this.filterBulkOrderGuid);

          if (data.uploadValidationMessages?.length > 0) {
            this.uploadTitle        = 'Upload Validation';
            this.uploadMessages     = data.uploadValidationMessages;
            this.setUploadMessagesVisible(true);
          }
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
  }

  public yesDeleteBulkOrder() {
    try {

      this.deleteInProgress = true;

      let orderGuid : string = this.filterBulkOrderGuid ?? "";
     
      this.ordersService.deleteBulkOrder(orderGuid)
      .pipe(
        catchError((error) => {
          this.deleteInProgress = false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.deleteInProgress = false;
   
          if (this.selectedBulkOrderSummary?.completedOrderCount == 0) {
             this.filterBulkOrderGuid = crypto.randomUUID();
          }
          this.pageheader.bulkOrderDropDownRefresh(this.filterCompanyID ?? -1, this.filterBulkOrderGuid);

          this.refresh();

          this.processComplete("All non provisioned bulk order entries have been deleted");
        },
        error: error => {
          if (error.message && error.message.includes("404")) {
            this.deleteInProgress = false;

            this.warningMessageMain="Bulk Delete failed";
            this.warningMessageSub ="Please contact the application vendor for assistance";

            this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
          } else {
            this.deleteInProgress = false;
            this.exceptionsService.handleException(new Error(error));
          }
        }
      });

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public yesDeleteBulkOrderEntry() {
    try {

      this.deleteInProgress = true;

      let orderGuid : string = this.filterBulkOrderGuid ?? "";
      let orderId   : number = this.selectedRowData.id ?? -1;
      let email     : string = this.selectedRowData.email ?? "";
     
      this.ordersService.deleteBulkOrderById(orderGuid, orderId)
      .pipe(
        catchError((error) => {
          this.deleteInProgress = false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.deleteInProgress = false;
   
          if (this.selectedBulkOrderSummary?.totalOrderCount == 1) {
             this.filterBulkOrderGuid = crypto.randomUUID();
          }
          this.pageheader.bulkOrderDropDownRefresh(this.filterCompanyID ?? -1, this.filterBulkOrderGuid);

          this.refresh();

          this.processComplete(email + " bulk order entry has been deleted");
        },
        error: error => {
          if (error.message && error.message.includes("404")) {
            this.deleteInProgress = false;

            this.warningMessageMain="Delete failed";
            this.warningMessageSub ="Please contact the application vendor for assistance";

            this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
          } else {
            this.deleteInProgress = false;
            this.exceptionsService.handleException(new Error(error));
          }
        }
      });

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private processComplete(submessage:string) {
    try {
      this.completedModalForm.openForm("Congratulations", submessage);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getBulkOrderMenuText(bulkordersummary: BulkOrderSummaryDTO) {

    const getSpaces = (spaces: number): string => {
      const spaceString = '&nbsp;'.repeat(spaces);
      return spaceString;
    };

    const getDate = (date: Date | undefined): string => {
      if (date == undefined) {
        return "";
      } 
      let localDateTime = new Date(date);
      const dateString = formatDate(localDateTime,'yyyy-MM-dd HH:mm');
      return dateString;
    };

    const getOrderInfo = (orderInfo: BulkOrderSummaryDTO): string => {
      // const ordersSentInfo    =       getSpaces(1) + ((orderInfo.ordersSentCount == 0   || orderInfo.ordersSentCount   == null) ? "0" : orderInfo.ordersSentCount) + ' Placed';
      // const validOrdersInfo   = ',' + getSpaces(1) + ((orderInfo.validOrderCount == 0   || orderInfo.validOrderCount   == null) ? "0" : orderInfo.validOrderCount) + ' Valid';
      // const invalidOrdersInfo = ',' + getSpaces(1) + ((orderInfo.invalidOrderCount == 0 || orderInfo.invalidOrderCount == null) ? "0" : orderInfo.invalidOrderCount) + ' Invalid';
      // const totalString       = orderInfo.totalOrderCount + (orderInfo.totalOrderCount > 1 ? ' orders (' : ' order (') + ordersSentInfo + validOrdersInfo + invalidOrdersInfo + ' )';
      const orderStatus = ' (' + orderInfo.bulkOrderStatus + ')';
      return orderStatus; //totalString;
    };

    //return {id: bulkordersummary.bulkOrderGuid, description: getDate(bulkordersummary.enteredDate) + getSpaces(10) + bulkordersummary.fileName?.substring(0,30) + getSpaces(40 - bulkordersummary.fileName?.substring(0,30).length) + getOrderInfo(bulkordersummary)};
    return {id: bulkordersummary.bulkOrderGuid, description: getDate(bulkordersummary.enteredDate) + getSpaces(10) + bulkordersummary.fileName?.substring(0,50) + getOrderInfo(bulkordersummary)};
  }

  public completedModalHasBeenClosed() {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public validateFileData(filedata : any[]) : string[] {
    let errormessage = [];
    let abortMessage = ' Upload Aborted';
    if (filedata.length < 1) {
      throwError(() => new Error('No data found to upload!' + abortMessage));
    } else {
      let firstrowdata = filedata[0];
      //RBW_20260604 - Accept the new combined header or the original one (for templates downloaded before the change)
      if (!('First Name/Location Id' in firstrowdata) && !('First Name' in firstrowdata)) {
         errormessage.push('First Name/Location Id column not found!' + abortMessage);
      }
      if (!('Last Name/Asset Id' in firstrowdata) && !('Last Name' in firstrowdata)) {
         errormessage.push('Last Name/Asset Id column not found!' + abortMessage);
      }
      if (!('Email' in firstrowdata)) {
         errormessage.push('Email column not found!' + abortMessage);
      }
      if (!('Mobile' in firstrowdata)) {
         errormessage.push('Mobile column not found!' + abortMessage);
      }
      if (!('User Ref 1' in firstrowdata) && !('User Tag' in firstrowdata)) {
         errormessage.push('User Ref 1 column not found!' + abortMessage);
      }
      if (this.showCostCentres) {
        if (!('Cost Centre' in firstrowdata)) {
           errormessage.push('Cost Centre column not found!' + abortMessage);
        }
        if (!('Cost Centre 2' in firstrowdata)) {
           errormessage.push('Cost Centre 2 column not found!' + abortMessage);
        }
      }
      if (!('EID' in firstrowdata)) {
         errormessage.push('EID column not found!' + abortMessage);
      }
      if (!('Product' in firstrowdata)) {
         errormessage.push('Product column not found!' + abortMessage);
      }
      if (!('Sim Type' in firstrowdata)) {
         errormessage.push('Sim Type column not found!' + abortMessage);
      }
      if (!('Deploy Method' in firstrowdata) && !('Deployment Method' in firstrowdata) && !('Provision Type' in firstrowdata)) {
         errormessage.push('Deploy Method column not found!' + abortMessage);
      }
      if (!('ICCID' in firstrowdata)) {
         errormessage.push('ICCID column not found!' + abortMessage);
      }
      if (!('Use Type' in firstrowdata) && !('IsIOTDevice' in firstrowdata)) {
         errormessage.push('Use Type column not found!' + abortMessage);
      }
      if (!('Device OS' in firstrowdata)) {
         errormessage.push('Device OS column not found!' + abortMessage);
      }
    }

    return errormessage;
  }

public exportToExcel() {
  try {
    const countries$ = this.useInternationalDialCode ? this.countriesService.get() : of(<CountryDTO[]>[]);

    forkJoin({ products: this.productsService.getAvailableIdAndDescription(), countries: countries$, logo: from(this.loadLogoBase64()) })
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next : result => { this.buildAndSaveTemplate(<IdAndDescriptionDTO[]>(result.products ?? []), <CountryDTO[]>(result.countries ?? []), result.logo ?? ""); },
        error: error  => { this.exceptionsService.handleException(new Error(error)); }
      });
  }
  catch(e) {
    this.exceptionsService.handleException(<Error>e);
  }
}

//RBW_20260814 - Load the SureSIM logo as raw base64 (no data: prefix) for embedding in the template. Returns "" if unavailable so the template still generates.
private async loadLogoBase64(): Promise<string> {
  try {
    const response = await fetch("assets/images/SureSIM-Logo-Dark-400.png");

    if (!response.ok)
      return "";

    const blob = await response.blob();

    return await new Promise<string>((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(((reader.result as string) ?? "").split(",")[1] ?? "");
      reader.onerror   = () => resolve("");
      reader.readAsDataURL(blob);
    });
  }
  catch {
    return "";
  }
}

private buildAndSaveTemplate(products: IdAndDescriptionDTO[], countries: CountryDTO[], logoBase64: string): void {
  try {
    const fileName = "Bulk Provision Template";
    const columns: { key: string; header: string }[] = [
      { key: "simType",             header: "Sim Type"               },
      { key: "isIOTDevice",         header: "Use Type"               },
      { key: "provisionType",       header: "Deploy Method"          },
      { key: "deviceOS",            header: "Device OS"              },
      { key: "eid",                 header: "EID"                    },
      { key: "iccid",               header: "ICCID"                  },
      { key: "simRef",              header: "SIM Ref"                },
      { key: "product",             header: "Product"                },
      { key: "firstname",           header: "First Name/Location Id" },
      { key: "lastname",            header: "Last Name/Asset Id"     },
      { key: "email",               header: "Email"                  },
      ...(this.useInternationalDialCode ? [
      { key: "mobileIntCode",       header: "Country Code"           }] : []),
      { key: "mobile",              header: "Mobile"                 },
      { key: "tag",                 header: "User Ref 1"             },
      { key: "tag2",                header: "User Ref 2"             },
      ...(this.showCostCentres ? [
      { key: "costCentre",          header: "Cost Centre"            },
      { key: "costCentre2",         header: "Cost Centre 2"          }] : []),
      { key: "inheritCompanyLimit", header: "Inherit Company Limit"  },
      { key: "limitType",           header: "Limit Type"             },
      { key: "limitAmount",         header: "Limit Amount"           },
      { key: "dataWeightCode",      header: "Limit Data Weight"      }
    ];
    const headers = columns.map(column => column.header);

    const workbook = new Workbook();

    const template = workbook.addWorksheet("Template");

    const columnWidths: { [key: string]: number } = {
      product: 45,
      eid    : 34,
      iccid  : 24,
      simRef : 20,
      email  : 30,
      tag    : 18,
      tag2   : 18,
    };
    headers.forEach((header, i) => { template.getColumn(i + 1).width = columnWidths[columns[i].key] ?? Math.max(header.length + 2, 16); });

    const colOf: { [key: string]: string } = {};
    columns.forEach((column, i) => { colOf[column.key] = template.getColumn(i + 1).letter; });

    if (logoBase64) {
      const logoId = workbook.addImage({ base64: logoBase64, extension: "png" });
      template.addImage(logoId, { tl: { col: 0, row: 0.2 }, ext: { width: 190, height: 57 } });
    }

    let topRow = 4; // rows 1-3 left for the logo

    template.getCell(`A${topRow}`).value = "Bulk Provisioning Template";
    template.getCell(`A${topRow}`).font  = { name: "Arial", bold: true, size: 16 };
    topRow += 2;

    template.getCell(`A${topRow}`).value = "How to use:";
    template.getCell(`A${topRow}`).font  = { name: "Arial", bold: true };
    topRow += 1;

    const instructions = [
      "Existing user (already on the platform): you only need their Email - it identifies them. Name, mobile and user refs are ignored for existing users.",
      "First Name / Last Name / Mobile / User Ref 1 & 2 are only used when creating a NEW user.",
      "Physical SIMs (Sim Type = SIM) deploy via ICCID; eSIMs use EID / SMS / Email / Manual.",
      "Grey cells are not required for that row (its other choices don't need them) - just fill in the white cells.",
      "See the 'Allowed Values' tab for the full list of options and rules for each column."
    ];
    instructions.forEach(line => {
      template.getCell(`A${topRow}`).value = "•  " + line;
      topRow += 1;
    });

    topRow += 1; // blank spacer row

    const sectionHeaderRowIndex = topRow;
    const headerRowIndex        = sectionHeaderRowIndex + 1;
    const firstDataRow          = headerRowIndex + 1;
    const lastRow               = firstDataRow + 198; // ~199 data rows

    //RBW_20260814 - White-fill the intro block so the sheet gridlines don't show behind the logo / title / instructions
    for (let r = 1; r < sectionHeaderRowIndex; r++) {
      for (let c = 1; c <= columns.length; c++) {
        template.getCell(r, c).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFFFF" } };
      }
    }

    const columnSection: { [key: string]: string } = {
      simType: "Device", isIOTDevice: "Device", provisionType: "Device", deviceOS: "Device", eid: "Device", iccid: "Device", simRef: "Device", product: "Device",
      firstname: "User", lastname: "User", email: "User", mobileIntCode: "User", mobile: "User", tag: "User", tag2: "User", costCentre: "User", costCentre2: "User",
      inheritCompanyLimit: "Limit", limitType: "Limit", limitAmount: "Limit", dataWeightCode: "Limit"
    };
    const sectionColour: { [key: string]: string } = { Device: "FF4472C4", User: "FF70AD47", Limit: "FFED7D31" };

    columns.forEach((column, i) => {
      const cell = template.getCell(headerRowIndex, i + 1);
      const argb = sectionColour[columnSection[column.key]];
      cell.value = column.header;
      cell.font  = { name: "Arial", bold: true, color: argb ? { argb: "FFFFFFFF" } : undefined };
      if (argb)
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
    });

    let runStart = 0;
    for (let i = 1; i <= columns.length; i++) {
      const prevSection = columnSection[columns[i - 1].key];
      const currSection = i < columns.length ? columnSection[columns[i].key] : undefined;

      if (currSection !== prevSection) {
        const argb     = sectionColour[prevSection];
        const startCol = runStart + 1;
        const endCol   = i;

        if (endCol > startCol)
          template.mergeCells(sectionHeaderRowIndex, startCol, sectionHeaderRowIndex, endCol);

        const cell = template.getCell(sectionHeaderRowIndex, startCol);
        cell.value     = prevSection;
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.font      = { name: "Arial", bold: true, size: 12, color: argb ? { argb: "FFFFFFFF" } : undefined };
        if (argb)
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };

        runStart = i;
      }
    }

    template.views = [{ state: "frozen", ySplit: headerRowIndex }];

    //RBW_20260604 - Reference sheet documenting allowed values and the rules
    const reference = workbook.addWorksheet("Allowed Values");
    [
      ["Allowed Values & Rules"],
      [],
      ["Field", "Allowed values", "Required"],
      ["Sim Type", "eSIM | SIM", "Always"],
      ["Use Type", "Physical User | IOT Device", "Always (leave name/email/mobile blank for an IOT Device)"],
      ["Deploy Method", "EID | ICCID | SMS | Email | Manual", "Always (ICCID for physical SIMs; Manual stores the activation details to send later, eSIM only). An IOT Device can only use EID or Manual, or ICCID for a physical SIM."],
      ["Device OS", "Apple iOS | Android | Windows", "When Deploy Method = SMS or Email"],
      ["EID", "32-digit number", "When Deploy Method = EID (eSIM only)"],
      ["ICCID", "Up to 100 characters", "When Sim Type = SIM (physical) - deployed via ICCID"],
      ["Inherit Company Limit", "Yes | No", "Default Yes. Set No to override the company usage limit for this SIM."],
      ["Limit Type", "No Limit | Spend | Data", "Required when Inherit Company Limit = No"],
      ["Limit Amount", "Number", "Required when Limit Type = Spend or Data"],
      ["Limit Data Weight", "MB | GB", "Required when Limit Type = Data"],
      ...(this.useInternationalDialCode ? [["Country Code", "Pick a country from the list", "Physical User rows only - sets the mobile's country dialling code"]] : []),
      [],
      ["A physical SIM (Sim Type = SIM) can only use Deploy Method = ICCID (the only valid method for a physical SIM)."],
      ["An IOT Device has no email or mobile, so it can only use Deploy Method = EID or Manual (or ICCID for a physical SIM) - SMS / Email are not offered."]
    ].forEach(row => reference.addRow(row));
    reference.getRow(1).font = { name: "Arial", bold: true };
    reference.getRow(3).font = { name: "Arial", bold: true };
    reference.getColumn(1).width = 18;
    reference.getColumn(2).width = 32;
    reference.getColumn(3).width = 46;

    //RBW_20260604 - Hidden sheet holding the valid product list so the Product dropdown can reference a range (avoids Excel's inline-list length limit)
    const lists = workbook.addWorksheet("Lists", { state: "veryHidden" });
    products.forEach(product => lists.addRow([product.description]));

    const dialCodeOptions: string[] = countries
      .filter(country => country.countryName && country.diallingCode)
      .map(country => `${country.countryName} (+${this.phoneNumberService.toDigits(country.diallingCode)})`);
    const dialCodes = workbook.addWorksheet("DialCodes", { state: "veryHidden" });
    dialCodeOptions.forEach(option => dialCodes.addRow([option]));

    const deployMethods = workbook.addWorksheet("DeployMethods", { state: "veryHidden" });
    ["EID", "SMS", "Email", "Manual"].forEach((method, i) => deployMethods.getCell(`A${i + 1}`).value = method); // eSIM (Physical User) options
    deployMethods.getCell("B1").value = "ICCID";                                                                  // SIM (physical) option
    deployMethods.getCell("C1").value = "EID";                                                                    // eSIM + IOT Device options
    deployMethods.getCell("C2").value = "Manual";                                                                 // (no SMS/Email - an IOT device has no email/mobile)
    //RBW_20260923 - Deploy Method depends on BOTH Sim Type and Use Type. An IOT Device carries no email/mobile, so SMS/Email must not be
    //offered; an IOT eSIM can use EID or Manual (Manual just stores the activation details to send to the operator later). Keyed by
    //"<SimType><UseType-no-spaces>" via INDIRECT, with the plain Sim Type names kept as the fallback for a blank Use Type.
    workbook.definedNames.add("DeployMethods!$A$1:$A$4", "eSIM");             // eSIM, Use Type blank
    workbook.definedNames.add("DeployMethods!$A$1:$A$4", "eSIMPhysicalUser"); // eSIM + Physical User -> EID/SMS/Email/Manual
    workbook.definedNames.add("DeployMethods!$C$1:$C$2", "eSIMIOTDevice");    // eSIM + IOT Device    -> EID or Manual
    workbook.definedNames.add("DeployMethods!$B$1:$B$1", "SIM");             // SIM, Use Type blank
    workbook.definedNames.add("DeployMethods!$B$1:$B$1", "SIMPhysicalUser"); // SIM + Physical User  -> ICCID
    workbook.definedNames.add("DeployMethods!$B$1:$B$1", "SIMIOTDevice");    // SIM + IOT Device     -> ICCID

    //RBW_20260604 - In-cell dropdowns applied to a generous row range so rows added by the user are validated too
    for (let row = firstDataRow; row <= lastRow; row++) {
      //RBW_20260604 - Keep the long digit identifiers as text so Excel doesn't reformat them (e.g. strip leading 0 / use scientific notation)
      template.getCell(`${colOf["mobile"]}${row}`).numFmt = "@"; // Mobile
      template.getCell(`${colOf["eid"]}${row}`).numFmt    = "@"; // EID
      template.getCell(`${colOf["iccid"]}${row}`).numFmt  = "@"; // ICCID

      template.getCell(`${colOf["simType"]}${row}`).dataValidation       = { type: "list", allowBlank: true, formulae: ['"eSIM,SIM"'] };                 // Sim Type
      template.getCell(`${colOf["provisionType"]}${row}`).dataValidation = { type: "list", allowBlank: true, formulae: [`INDIRECT($${colOf["simType"]}${row}&SUBSTITUTE($${colOf["isIOTDevice"]}${row}," ",""))`] }; // Deploy Method - depends on Sim Type + Use Type (IOT Device hides SMS/Email/Manual)
      template.getCell(`${colOf["deviceOS"]}${row}`).dataValidation      = { type: "list", allowBlank: true, formulae: ['"Apple iOS,Android,Windows"'] };// Device OS
      template.getCell(`${colOf["isIOTDevice"]}${row}`).dataValidation   = { type: "list", allowBlank: true, formulae: ['"Physical User,IOT Device"'] };  // Use Type
      if (products.length > 0) {
        template.getCell(`${colOf["product"]}${row}`).dataValidation     = { type: "list", allowBlank: true, formulae: [`Lists!$A$1:$A$${products.length}`] }; // Product
      }
      if (this.useInternationalDialCode && dialCodeOptions.length > 0) {
        template.getCell(`${colOf["mobileIntCode"]}${row}`).dataValidation = { type: "list", allowBlank: true, formulae: [`DialCodes!$A$1:$A$${dialCodeOptions.length}`] }; // Country Code
      }

      template.getCell(`${colOf["inheritCompanyLimit"]}${row}`).value          = "Yes";                                                                    // Inherit Company Limit (default)
      template.getCell(`${colOf["inheritCompanyLimit"]}${row}`).dataValidation = { type: "list", allowBlank: true, formulae: ['"Yes,No"'] };               // Inherit Company Limit
      template.getCell(`${colOf["limitType"]}${row}`).dataValidation           = { type: "list", allowBlank: true, formulae: ['"No Limit,Spend,Data"'] };  // Limit Type
      template.getCell(`${colOf["dataWeightCode"]}${row}`).dataValidation      = { type: "list", allowBlank: true, formulae: ['"MB,GB"'] };                 // Data Weight
    }

    //RBW_20260807 - Grey out cells that don't apply to the row's Sim Type / Provision Type / Use Type, so it's obvious what to fill in.
    const greyFill = { type: "pattern" as const, pattern: "solid" as const, bgColor: { argb: "FFD9D9D9" }, fgColor: { argb: "FFD9D9D9" } };
    const greyWhen = (columnLetter: string, formula: string) =>
      template.addConditionalFormatting({
        ref: `${columnLetter}${firstDataRow}:${columnLetter}${lastRow}`,
        rules: [{ type: "expression", priority: 1, formulae: [formula], style: { fill: greyFill } }]
      });

    const fdr        = firstDataRow; // conditional-formatting formulas are relative to the first data row
    const iotCol     = colOf["isIOTDevice"];
    const simCol     = colOf["simType"];
    const provCol    = colOf["provisionType"];
    const inheritCol = colOf["inheritCompanyLimit"];
    const limitCol   = colOf["limitType"];

    greyWhen(colOf["email"],  `$${iotCol}${fdr}="IOT Device"`);                                  // Email       - not used for an IOT device
    greyWhen(colOf["mobile"], `$${iotCol}${fdr}="IOT Device"`);                                  // Mobile      - not used for an IOT device
    if (this.useInternationalDialCode) {
      greyWhen(colOf["mobileIntCode"], `$${iotCol}${fdr}="IOT Device"`);                         // Country Code- not used for an IOT device
    }
    if (this.showCostCentres) {
      greyWhen(colOf["costCentre"],  `$${iotCol}${fdr}="IOT Device"`);                           // Cost Centre   - not used for an IOT device
      greyWhen(colOf["costCentre2"], `$${iotCol}${fdr}="IOT Device"`);                           // Cost Centre 2 - not used for an IOT device
    }
    greyWhen(colOf["eid"],            `OR($${simCol}${fdr}="SIM",AND($${provCol}${fdr}<>"",$${provCol}${fdr}<>"EID"))`); // EID - not for a physical SIM, nor SMS/Email/Manual
    greyWhen(colOf["iccid"],          `$${simCol}${fdr}="eSIM"`);                                 // ICCID       - only a physical SIM uses one
    greyWhen(colOf["deviceOS"],       `OR($${provCol}${fdr}="EID",$${provCol}${fdr}="ICCID",$${provCol}${fdr}="Manual")`); // Device OS - only needed for SMS/Email
    greyWhen(colOf["limitType"],      `$${inheritCol}${fdr}="Yes"`);                              // Limit Type  - only when NOT inheriting the company limit
    greyWhen(colOf["limitAmount"],    `OR($${inheritCol}${fdr}="Yes",$${limitCol}${fdr}="No Limit")`); // Limit Amount- not for inherited nor No Limit
    greyWhen(colOf["dataWeightCode"], `OR($${inheritCol}${fdr}="Yes",$${limitCol}${fdr}<>"Data")`); // Data Weight - only for a Data limit

    const currencyNumFmt = `"${this.companyCurrencySymbol}"#,##0.00`;
    template.addConditionalFormatting({
      ref: `${colOf["limitAmount"]}${firstDataRow}:${colOf["limitAmount"]}${lastRow}`,
      rules: [{ type: "expression", priority: 1, formulae: [`AND($${inheritCol}${fdr}="No",$${limitCol}${fdr}="Spend")`], style: { numFmt: currencyNumFmt } }]
    });

    workbook.xlsx.writeBuffer()
      .then((buffer: BlobPart) => {
        saveAs(new Blob([buffer], { type: "application/octet-stream" }), `${fileName}.xlsx`);
        this.completedModalForm.openForm("Bulk Provision Template Created", `The ${fileName}.xlsx file can be found in downloads`);
      })
      .catch((error) => { this.exceptionsService.handleException(<Error>error); });
  }
  catch(e) {
    this.exceptionsService.handleException(<Error>e);
  }
}
}
